(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-video"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ella-fast-hero')) {
  customElements.define('ella-fast-hero', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound) return;
      this.dataset.bound = 'true';
      const video = this.querySelector('video');
      const button = this.querySelector('button');
      if (!video || !button) return;
      const start = () => {
        if (!video.getAttribute('src')) {
          video.src = window.matchMedia('(min-width: 769px)').matches ? this.dataset.desktopSrc : this.dataset.mobileSrc;
        }
        video.muted = true;
        video.play().catch(() => {});
      };
      video.addEventListener('playing', () => {
        this.setAttribute('data-playing', '');
        button.textContent = button.dataset.pauseLabel;
        button.setAttribute('aria-pressed', 'true');
      });
      video.addEventListener('pause', () => {
        button.textContent = button.dataset.playLabel;
        button.setAttribute('aria-pressed', 'false');
      });
      button.addEventListener('click', () => video.paused ? start() : video.pause());
      if (window.matchMedia('(min-width: 769px) and (prefers-reduced-motion: no-preference)').matches) {
        if (document.readyState === 'complete') start();
        else window.addEventListener('load', start, {once:true});
      }
    }
    disconnectedCallback() {
      this.querySelector('video')?.pause();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
